<template>
    <!-- start aside -->
    <aside class="sidebar product--sidebar" @click="toggleFilterClose($event)">
        <!-- end /.sidebar-card -->
        <div class="product--sidebar-wrapper" ref="wrapper">
            <div class="sidebar-card card--filter" v-if="computedFilters && computedFilters.categories && computedFilters.categories.length">
                <a class="card-title" href="#collapse2" role="button" data-toggle="collapse"
                   aria-expanded="false" aria-controls="collapse2">
                    <h4>Категории
                        <span class="lnr lnr-chevron-down"></span>
                    </h4>
                </a>
                <div class="collapse show collapsible-content" id="collapse2">
                    <ul class="card-content">
                        <li v-for="category in computedFilters.categories">
                            <div class="custom-checkbox2">
                                <input type="checkbox" v-model="selectedCategoriesIds"
                                       :id="'category_' + category.id" :value="category.id" class=""
                                       name="categories[]">
                                <label :for="'category_' + category.id">
                                    <span class="square"></span>{{ category.name }}
                                </label>
                            </div>
                        </li>
                    </ul>
                </div>
            </div>
            <!-- end /.sidebar-card -->

            <div class="sidebar-card card--filter" v-if="computedFilters && computedFilters.donationsFilter && computedFilters.donationsFilter.length">
                <a class="card-title" href="#collapse5" role="button" data-toggle="collapse"
                   aria-expanded="false" aria-controls="collapse5">
                    <h4>Пожертвования
                        <span class="lnr lnr-chevron-down"></span>
                    </h4>
                </a>

                <div class="collapse show collapsible-content" id="collapse5">
                    <ul class="card-content">
                        <li v-for="d in computedFilters.donationsFilter">
                            <div class="custom-checkbox2">
                                <input type="checkbox"
                                       @change="dynamicFilter( 'donations_filter', d, $event )"
                                       :checked="computedActiveFilters.donations_filter === d"
                                       :id="`filter_${d}`">
                                <label :for="`filter_${d}`">
                                    <span class="square"></span>
                                    <template v-if="d === '<40'">Меньше 40%</template>
                                    <template v-if="d === '40-80'">От 40% до 80%</template>
                                    <template v-if="d === '>80'">Осталось чуть-чуть</template>
                                </label>
                            </div>
                        </li>
                    </ul>
                </div>
            </div>
            <!-- end /.sidebar-card -->

            <div class="sidebar-card card--filter" v-if="computedFilters">
                <a class="card-title" href="#collapse6" role="button" data-toggle="collapse"
                   aria-expanded="false" aria-controls="collapse6">
                    <h4>Подписка
                        <span class="lnr lnr-chevron-down"></span>
                    </h4>
                </a>
                <div class="collapse show collapsible-content" id="collapse6">
                    <ul class="card-content">
                        <li>
                            <div class="custom-checkbox2">
                                <input type="checkbox" id="subscription"
                                       @change="dynamicFilter( 'allow_autopay', 1, $event )"
                                       :checked="subscription === 1"
                                >
                                <label for="subscription">
                                    <span class="square"></span> Доступна подписка
                                </label>
                            </div>
                        </li>
                    </ul>
                </div>
            </div>
            <!-- end /.sidebar-card -->
            <div class="sidebar-card card--slider">
                <a class="card-title" href="#collapse4" role="button" data-toggle="collapse"
                   aria-expanded="false" aria-controls="collapse3">
                    <h4>Город
                        <span class="lnr lnr-chevron-down"></span>
                    </h4>
                </a>
                <div class="collapse show collapsible-content" id="collapse4">
                    <div class="card-content">
                        <div class="form-group mt-2">
                            <label for="city_id">Населенный пункт</label>
                            <div class="" style="position:relative;">
                                <input v-model="citySearch" class="form-control city-filter" autocomplete="off"
                                       id="city_id"
                                       placeholder="Начните набирать название нас. пункта"/>
                                <div class="search-result" v-if="computedSearch.cities.length">
                                    <div class="city-item"  v-for="city in computedSearch.cities"
                                         @click.prevent="
                                         setState( { key: 'search', data:{ citySearch: city.name, citySelected: city.name, city_id: city.id, cities: [] } });
                                         setState( { key: 'activeProjectsFilters', data:{ ...computedActiveFilters, city_id: city.id, page: 1 } })">
                                        {{ city.name }}
                                    </div>
                                </div>
                                <div class="search-result"
                                     v-if="!computedSearch.cities.length && computedSearch.citySearch && computedSearch.citySearch !== computedSearch.citySelected">
                                    <div class="city-item">Ничего не найдено</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <!-- end /.sidebar-card -->
        </div>

        <button id="sidebar-toggle" ref="toggleBtn" @click.prevent="toggleFilterOpen($event)">

            <svg width="23" height="15" viewBox="0 0 23 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M0 0.882353C0 0.395037 0.466882 0 1.04278 0H21.8984C22.4743 0 22.9412 0.395037 22.9412 0.882353C22.9412 1.36967 22.4743 1.76471 21.8984 1.76471H1.04278C0.466882 1.76471 0 1.36967 0 0.882353Z" fill="white"/>
                <path d="M7.05884 9.7059C7.05884 9.21859 7.36273 8.82355 7.73757 8.82355H15.2036C15.5785 8.82355 15.8824 9.21859 15.8824 9.7059C15.8824 10.1932 15.5785 10.5883 15.2036 10.5883H7.73757C7.36273 10.5883 7.05884 10.1932 7.05884 9.7059Z" fill="white"/>
                <path d="M4.41187 5.2941C4.41187 4.80679 4.89809 4.41174 5.49784 4.41174H17.4435C18.0433 4.41174 18.5295 4.80679 18.5295 5.2941C18.5295 5.7814 18.0433 6.17645 17.4435 6.17645H5.49784C4.89809 6.17645 4.41187 5.7814 4.41187 5.2941Z" fill="white"/>
                <path d="M9.88229 13.2353C9.29761 13.2353 8.82349 13.6303 8.82349 14.1176C8.82349 14.605 9.29761 15 9.88229 15H13.0588C13.6435 15 14.1176 14.605 14.1176 14.1176C14.1176 13.6303 13.6435 13.2353 13.0588 13.2353H9.88229Z" fill="white"/>
            </svg>


        </button>

    </aside>
</template>

<script>

import { mapGetters, mapMutations, mapActions } from 'vuex';

export default {
    name: "FilterProjects",

    computed: {

        ...mapGetters({ sliceState: 'sliceByKey' }),

        computedFilters() { return this.sliceState( 'filtersProjects' ) },

        computedActiveFilters(){  return this.sliceState( 'activeProjectsFilters' ) },

        computedSearch() { return this.sliceState( 'search' ) },

        toggleFilter() { return this.sliceState( 'toggleFilter' ) },

        fetched() { return this.sliceState( 'fetched' ) },

        citySearch:{
            get(){ return this.computedSearch.citySearch },
            set( val ){
                if( ! val ) {

                    if( this.computedSearch.city_id ){
                        this.setState({ key: 'activeProjectsFilters', data: { ...this.computedActiveFilters, city_id: null} })
                    }

                    return this.resetSliceState({key: 'search'});
                }

                if( val  &&  val  !==  this.computedSearch.citySelected ){

                    this.search( val );

                }

            }
        },

        selectedCategoriesIds:{
            get(){ return this.computedActiveFilters.project_category_id },
            set( val ){ this.setState( { key: 'activeProjectsFilters' , data: { ...this.computedActiveFilters, project_category_id: val, page: 1 } } ) }
        },

        subscription: {
            get(){ return +this.computedActiveFilters.allow_autopay },
        }

    },

    watch: {

        computedActiveFilters() {
            if( this.fetched ) return;
            this.resetSliceState({ key: 'list' });
            this.setState({ key: 'fetched', data: true });
            this.list( { key: 'activeProjectsFilters' } );
        },

    },

    methods: {

        ...mapMutations({ setState: 'setterByKey', resetSliceState: 'resetByKey' }),
        ...mapActions({ list: 'getList', search: 'searchCities' }),


        dynamicFilter( target, filter, event ) {

            let checked = event.target.checked;

            if ( ! checked ) return this.setState( { key: 'activeProjectsFilters' , data: { ...this.computedActiveFilters, [`${target}`]: null, page: 1 } } );
            return this.setState( { key: 'activeProjectsFilters' , data: { ...this.computedActiveFilters, [`${target}`]: filter, page: 1 } } );
        },

        toggleFilterOpen(e){
            if (window.matchMedia("(min-width: 992px)").matches) return;


            this.setState( { key: 'toggleFilter', data: !this.toggleFilter });

            if( ! this.toggleFilter ) {
                return document.body.classList.remove('product-sidebar--open');
            }

            document.body.classList.add('product-sidebar--open');

        },

        toggleFilterClose(e){

            if (window.matchMedia("(min-width: 992px)").matches) return;

            const wrapper = this.$refs.wrapper;
            const btn = this.$refs.toggleBtn;

            if( ! wrapper.contains( e.target ) && ! btn.contains( e.target ) ){
                this.setState( { key: 'toggleFilter', data: false });
                document.body.classList.remove('product-sidebar--open');
            }

        },

    }


}
</script>

<style scoped>

</style>
